import { useMemo } from 'react';
const productTypeToPathKeyMap = {
  APP: 'APPS',
  AGENT: 'AGENTS',
  SOLUTIONS_PARTNER_PROFILE: 'SOLUTIONS_PARTNERS'
};
export function useBreadcrumbs({
  backBreadcrumb = false,
  pathKey,
  productType,
  slug,
  title
} = {}) {
  return useMemo(() => {
    if (backBreadcrumb) {
      return [{
        pathKey: 'HOME',
        isCurrentPage: false
      }];
    }
    const breadcrumbs = [{
      pathKey: 'HOME'
    }];
    const getProductTypePath = () => ({
      pathKey: productTypeToPathKeyMap[productType || 'APP'] || 'APPS',
      isCurrentPage: false
    });
    switch (pathKey) {
      case 'FEATURED_COLLECTION':
        return [...breadcrumbs, {
          pathKey: 'FEATURED',
          isCurrentPage: false
        }, {
          isCurrentPage: true,
          pathKey,
          slug,
          title
        }];
      case 'LISTING_DETAILS':
        return [...breadcrumbs, getProductTypePath(), {
          isCurrentPage: true,
          pathKey,
          slug,
          title
        }];
      default:
        return [...breadcrumbs, {
          pathKey,
          isCurrentPage: true
        }];
    }
  }, [backBreadcrumb, pathKey, productType, slug, title]);
}